<template>
  <div>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#007BFF"
      :is-full-page="true"
    >
    </loading>
    <div class="container-fluid">
      <div class="card pt-3">
        <div class="row starter-page">
          <div class="container-fluid ">
            <div class="row mb-2 align-items-center">
              <div class="col-md-3 col-12 mb-2">
                <flat-picker
                  v-model="selectedDate"
                  :config="dateConfig"
                  placeholder="Selecciona una fecha"
                  class="form-control"
                  style="width: 100%"
                  @on-change="onDateChange"
                />
              </div>
            </div>
            <div class="summary-header mb-3 p-3">
              <h3 class="mb-0 font-weight-bold">
                <i class="ni ni-single-02 text-primary mr-2"></i>
                <span class="ml-3 summary-badge"
                  >Calificados:
                  <span :style="{ color: '#ff4444', fontWeight: 'bold' }"
                    >{{ scoredItems.length }}/{{ totalItems }}</span
                  ></span
                >
                <span class="ml-3 summary-badge"
                  >| Puntuación:
                  <span :style="{ color: '#ff4444', fontWeight: 'bold' }"
                    >{{ isNaN(currentScore) ? 0 : currentScore }}/{{
                      isNaN(maxScore) ? 0 : maxScore
                    }}</span
                  ></span
                >
                <span class="ml-3 summary-badge"
                  >| Estado:
                  <span :style="{ color: globalColor, fontWeight: 'bold' }"
                    >{{ globalLabel }} ({{ globalPercent }}%)</span
                  ></span
                >
              </h3>
            </div>
            <vue-content-loading
              v-if="!loaded"
              :width="300"
              :height="170"
              primary="#bdc3c7"
              secondary="#95a5a6"
            >
              <svg:rect x="20" y="0" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="0" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="0" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="0" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="15" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="15" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="15" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="15" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="30" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="30" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="30" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="30" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="45" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="45" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="45" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="45" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="60" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="60" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="60" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="60" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="75" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="75" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="75" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="75" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="90" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="90" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="90" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="90" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="105" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="105" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="105" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="105" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="120" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="120" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="120" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="120" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="135" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="135" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="135" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="135" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="150" rx="3" ry="3" width="110" height="8" />
              <circle cx="206" cy="155" r="5" />
              <circle cx="219" cy="155" r="5" />
              <circle cx="232" cy="155" r="5" />
              <circle cx="245" cy="155" r="5" />
            </vue-content-loading>

            <!-- Tabla de checklist agrupada -->
            <table class="table checklist-table">
              <thead>
                <tr>
                  <th class="header-bg">ITEM DE CHECKLIST</th>
                  <th class="header-bg text-center">CALIFICACIÓN</th>
                  <th class="header-bg text-center">COMENTARIO</th>
                  <th class="header-bg text-center">ACCIÓN CORRECTIVA</th>
                </tr>
              </thead>
              <tbody v-for="category in checklist" :key="category.category">
                <tr :class="'group-header'">
                  <td colspan="4">{{ category.category }}</td>
                </tr>
                <tr
                  v-for="(item, idx) in category.items"
                  :key="item.item_id"
                  :class="[
                    'checklist-row',
                    idx % 2 === 0 ? 'row-alt' : '',
                    hoveredRow === item.item_id ? 'row-hover' : ''
                  ]"
                  @mouseenter="hoveredRow = item.item_id"
                  @mouseleave="hoveredRow = null"
                >
                  <td>
                    <!-- Ícono info -->
                    <span
                      style="cursor:pointer; margin-right:5px"
                      @click="showInfo(item)"
                    >
                      <i class="fa fa-info-circle info-icon"></i>
                    </span>
                    {{ item.label }}
                    <!-- Ícono foto -->
                    <span
                      v-if="item.photo"
                      style="cursor:pointer; margin-left:8px"
                      @click="modalPhoto(item)"
                    >
                      <i class="fa fa-camera photo-icon"></i>
                    </span>
                  </td>
                  <td class="text-center">
                    <span
                      v-if="item.value"
                      :class="[
                        'calificacion-label',
                        getCalificacionColor(item.value)
                      ]"
                    >
                      {{ item.value }}
                    </span>
                  </td>
                  <td>
                    <span v-if="item.comment && item.comment.trim() !== ''">
                      {{ item.comment }}
                    </span>
                    <span v-else>Sin comentario</span>
                  </td>
                  <td class="text-center">
                    <span
                      v-if="item.value"
                      v-html="getCorrectiveAction(item)"
                    ></span>
                    <span v-else>-</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <CustomModal
      :is-modal="showCustomModal"
      @closeModal="closeCustomModal"
      :closeOuth="true"
      width="xlg"
    >
      <template v-if="customModalType === 'info'">
        <div>
          <h2>{{ customModalTitle }}</h2>
          <div>{{ customModalContent }}</div>
        </div>
      </template>
      <template v-else-if="customModalType === 'photo'">
        <div>
          <h2>{{ customModalTitle }}</h2>
          <div v-if="customModalPhotos.length > 0">
            <div
              style="display: flex; flex-wrap: wrap; gap: 10px; justify-content: center"
            >
              <img
                v-for="(photo, idx) in customModalPhotos"
                :key="idx"
                :src="getImageUrl(photo)"
                style="max-width: 300px; max-height: 300px; border-radius: 8px"
              />
            </div>
          </div>
          <div v-else>No hay fotos disponibles</div>
        </div>
      </template>
    </CustomModal>
  </div>
</template>

<script>
import { Table, TableColumn, Select, Option, Tag } from "element-ui";
import BackofficeApi from "../../gateways/backoffice-api";
import { VueContentLoading } from "vue-content-loading";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Spanish } from "flatpickr/dist/l10n/es";
import Loading from "vue-loading-overlay";
import CustomModal from "../../components/CustomModal";
import "vue-loading-overlay/dist/vue-loading.css";
import Fuse from "fuse.js";
import { format } from "date-fns";
import moment from "moment";

export default {
  name: "Checklist",
  components: {
    VueContentLoading,
    CustomModal,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Tag.name]: Tag,
    flatPicker,
    Loading
  },
  data() {
    return {
      loaded: false,
      selectedFeedback: null,
      searchQuery: "",
      searchedData: [],
      isLoading: false,
      isExporting: false,
      catering_id: null,
      tableColumns: [
        {
          prop: "at",
          label: "Fecha",
          minWidth: 125,
          sortable: true
        },
        {
          prop: "customer",
          label: "Cliente",
          minWidth: 150,
          sortable: true
        },
        {
          prop: "restaurant_qualification",
          label: "Calificación",
          minWidth: 150,
          sortable: true
        }
      ],
      checklist: [],
      selectedKitchen: null,
      selectedRating: null,
      selectedDate: null,
      currentFilters: {},
      ratings: [
        { id: null, name: "todos" },
        { id: 5, name: "Muy satisfecho" },
        { id: 4, name: "Satisfecho" },
        { id: 3, name: "Neutral" },
        { id: 2, name: "Insatisfecho" },
        { id: 1, name: "Muy insatisfecho" }
      ],
      dateConfig: {
        mode: "single",
        dateFormat: "Y-m-d",
        locale: Spanish
      },
      aspectsMap: {
        tiempo_aceptable: "Tiempo aceptable",
        calidad_buena: "Calidad buena",
        calidad_neutral: "Calidad neutral",
        calidad_negativa: "Calidad negativa",
        trato_negativo: "Trato negativo"
      },
      modalInstruction: false,
      PhotoModal: false,
      tempPhoto: {
        photos: []
      },
      hoveredRow: null,
      showCustomModal: false,
      customModalTitle: "",
      customModalContent: "",
      customModalPhotos: [],
      customModalType: ""
    };
  },
  async mounted() {
    this.catering_id = JSON.parse(localStorage.getItem("userData")).catering_id;
    await this.fetchFeedbacks();
  },
  computed: {
    host() {
      return process.env.VUE_APP_API_BACKOFFICE_URL;
    },
    selectCheckList() {
      return item => {
        if (this.checklist !== undefined) {
          return this.checklist.filter(element => {
            return (
              element.category_id === item[0] || element.category_id === item[1]
            );
          });
        }
      };
    },
    totalItems() {
      return this.checklist.reduce((acc, cat) => acc + cat.items.length, 0);
    },
    scoredItems() {
      return this.checklist
        .flatMap(cat => cat.items)
        .filter(i => {
          if (i.type === "1-5") {
            const val = this.starStringToNumber(i.value);
            return !isNaN(val) && val >= 1 && val <= 5;
          }
          if (i.type === "si-no") {
            return i.value === "si" || i.value === "no";
          }
          return false;
        });
    },
    maxScore() {
      return this.checklist
        .flatMap(cat => cat.items)
        .reduce((acc, i) => {
          if (i.type === "1-5") return acc + 5;
          if (i.type === "si-no") return acc + 5;
          return acc;
        }, 0);
    },
    currentScore() {
      return this.checklist
        .flatMap(cat => cat.items)
        .reduce((acc, i) => {
          if (i.value == null || i.value === "") return acc;
          if (i.type === "1-5") {
            const val = this.starStringToNumber(i.value);
            return isNaN(val) ? acc : acc + val;
          }
          if (i.type === "si-no") return acc + (i.value === "si" ? 5 : 1);
          return acc;
        }, 0);
    },
    globalPercent() {
      if (!this.maxScore) return 100;
      return Math.round((this.currentScore / this.maxScore) * 100);
    },
    globalLabel() {
      if (this.globalPercent >= 90) return "Excelente";
      if (this.globalPercent >= 70) return "Aceptable";
      return "Crítico";
    },
    globalColor() {
      if (this.globalPercent >= 90) return "#56b57c";
      if (this.globalPercent >= 70) return "#ffd700";
      return "#ff4444";
    }
  },
  methods: {
    starStringToNumber(val) {
      switch (val) {
        case "Pésimo":
          return 1;
        case "Mal":
          return 2;
        case "Regular":
          return 3;
        case "Bien":
          return 4;
        case "Excelente":
          return 5;
        default:
          return null;
      }
    },
    getImageUrl(image) {
      return process.env.VUE_APP_API_PHOTO + image;
    },
    showDetails(order) {
      this.selectedFeedback = order;
    },
    async fetchFeedbacks(filters = {}) {
      this.isLoading = true;
      try {
        let dateParam = filters.date || this.selectedDate;
        let path =
          process.env.VUE_APP_API_BACKOFFICE_URL +
          "checklist/structure/" +
          this.catering_id +
          "/";
        if (dateParam) {
          path += dateParam;
        } else {
          path += moment().format("YYYY-MM-DD");
        }
        const response = await BackofficeApi.get(path);
        this.checklist = response.data;
      } catch (e) {
        console.error("Error al cargar los datos:", e);
        this.checklist = [];
      } finally {
        this.isLoading = false;
        this.loaded = true;
      }
    },
    getAspects(aspects) {
      try {
        return JSON.parse(aspects).filter(a => a !== "otro");
      } catch {
        return [];
      }
    },
    getAspectText(aspect) {
      return this.aspectsMap[aspect] || aspect;
    },
    getRatingTagType(rating) {
      switch (rating) {
        case 5:
          return "success";
        case 4:
          return "success";
        case 3:
          return "warning";
        case 2:
          return "danger";
        case 1:
          return "danger";
        default:
          return "info";
      }
    },
    formatDate(date) {
      return moment(date, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY HH:mm");
    },
    showInfo(item) {
      this.customModalTitle = "Instrucción";
      this.customModalContent = item.instruction || "Sin información";
      this.customModalType = "info";
      this.showCustomModal = true;
    },
    modalPhoto(item) {
      let photos = [];
      if (Array.isArray(item.photo)) {
        photos = item.photo;
      } else if (typeof item.photo === "string") {
        try {
          const arr = JSON.parse(item.photo);
          if (Array.isArray(arr)) {
            photos = arr;
          } else {
            photos = [item.photo];
          }
        } catch {
          photos = [item.photo];
        }
      }
      this.customModalTitle = "Fotos";
      this.customModalPhotos = photos;
      this.customModalType = "photo";
      this.showCustomModal = true;
    },
    getCalificacionColor(value) {
      if (typeof value === "string") {
        const val = value.toLowerCase();
        if (val.includes("excelente") || val === "si") return "badge-success";
        if (val.includes("bien")) return "badge-info";
        if (val.includes("regular")) return "badge-warning";
        if (val.includes("mal") || val === "no") return "badge-danger";
        if (val.includes("pésimo")) return "badge-purple";
      }
      if (value === 5 || value === "5") return "badge-success";
      if (value === 4 || value === "4") return "badge-info";
      if (value === 3 || value === "3") return "badge-warning";
      if (value === 2 || value === "2") return "badge-danger";
      if (value === 1 || value === "1") return "badge-danger";
      return "badge-default";
    },
    closeCustomModal() {
      this.showCustomModal = false;
      this.customModalContent = "";
      this.customModalPhotos = [];
      this.customModalType = "";
    },
    onDateChange(date) {
      if (Array.isArray(date)) {
        date = date[0];
      }
      if (date) {
        this.fetchFeedbacks({ date });
      }
    },
    getCorrectiveAction(item) {
      // Manejo para tipo "si-no"
      if (item.type === "si-no") {
        const action = item.corrective_actions.find(
          a => a.rating === (item.value === "si" ? "SI" : "NO")
        );

        if (action) {
          return `${action.action_description} (${action.resolution_time}h)`;
        }
        return item.value === "si"
          ? "No requiere acción"
          : "Renovación urgente";
      }

      // Manejo para tipo "1-5"
      if (item.type === "1-5") {
        const rating = this.starStringToNumber(item.value);
        const sortedActions = [...item.corrective_actions].sort(
          (a, b) => parseFloat(a.rating) - parseFloat(b.rating)
        );

        let selectedAction = null;
        for (const action of sortedActions) {
          if (parseFloat(action.rating) >= rating) {
            selectedAction = action;
            break;
          }
        }

        if (selectedAction) {
          return `${selectedAction.action_description} (<span class="resolution-time">${selectedAction.resolution_time}h</span>)`;
        }
      }

      return "No requiere acción";
    }
  },
  watch: {
    selectedDate(val) {
      this.onDateChange(val);
    }
  }
};
</script>

<style scoped lang="scss">
::v-deep .el-table .cell {
  word-break: break-word !important;
}

.score-inline {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.score-label {
  margin-right: 10px;
}

.score-value {
  font-weight: bold;
}

.checklist-table {
  width: 100%;
  border-collapse: collapse;
}

.checklist-table th,
.checklist-table td {
  padding: 8px;
  text-align: left;
}

.checklist-table th {
  background-color: #f2f2f2;
}

.checklist-row {
  background-color: #fff;
}

.checklist-row:hover {
  background-color: #f0f0f0;
}

.bg-hour {
  background-color: #e0e0e0;
}

.info-icon {
  color: #007bff;
}

.photo-icon {
  color: #4caf50;
}

.calificacion-label {
  padding: 2px 8px;
  border-radius: 4px;
  font-weight: bold;
}

.comment-text {
  white-space: pre-wrap;
}

.custom-preview-markup {
  width: 100%;
  height: auto;
}

.summary-header {
  background: #f8fafc;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
}
.summary-badge {
  font-size: 1.1em;
  margin-right: 10px;
}
.header-bg {
  background: #e9ecef;
  color: #333;
  font-weight: 600;
}
.group-header {
  background: #d1e7dd !important;
  color: #1b4332;
  font-weight: bold;
}
.row-alt {
  background: #f6fafd;
}
.badge-success {
  background: #43a047;
  color: #fff;
}
.badge-info {
  background: #07a0e7;
  color: #fff;
}
.badge-warning {
  background: #fbc02d;
  color: #333;
}
.badge-danger {
  background: #e53935;
  color: #fff;
}
.badge-purple {
  background: #5e35b1;
  color: #fff;
}
.badge-default {
  background: #bdbdbd;
  color: #fff;
}
.resolution-time {
  color: #e53935;
  font-weight: bold;
}
</style>
